<template>
    <div class="Toastr">
        <Toast v-for="(message, index) in messages" :key="index"
            :level="message.level"
            :text="message.text" />
    </div>
</template>

<script>
import Toast from './ToastrItem';
export default {

    components: {
        Toast
    },

    props: {
        notify: {
            required: true,
            type: Array
        }
    },

    data() {
        return {
            messages: [
            ]
        }
    },

    methods: {
        add(message) {
            this.messages.push(message);
        }
    },

    created() {
        this.messages = this.notify;

        window.events.$on(
            'toast', message => this.add(message)
        );
    }
}
</script>

<style lang="scss">

    .Toastr {
        display: flex;
        flex-direction: column-reverse; // new on top
        position: fixed;
        bottom: 1rem;
        right: 1rem;
        width: 100%;
        max-width: 300px;
        opacity: .85;
        overflow: hidden;
    }

    .Toastr__item {
        position: relative;
        width: 100%;
        margin: .2rem 0;
        padding: 1rem;
        padding-left: 3rem;
        font-size: .9rem;
        color: #fff;
        border-radius: .25rem;
        background-position: .8rem center;
        background-repeat: no-repeat;
        overflow: hidden;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.02), 0 4px 6px -2px rgba(0, 0, 0, 0.01);
    }

    .Toastr__item--info {
        background-color: var(--accent);
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="%23fff" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="8"></line></svg>');
    }

    .Toastr__item--error {
        background-color: var(--error);
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="%23fff" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>');
    }

    .Toastr__item__progressbar {
        width: 0;
        opacity: .25;
        content: '';
        height: 4px;
        background: #000;
        position: absolute;
        bottom: 0;
        left: 0;
        transition: width 3s linear;
    }

    .Toastr__transition-enter-active, .Toastr__transition-leave-active {
        transition: .5s;
        transform: translateX(0);
    }
    .Toastr__transition-enter {
        transform: translateX(300px);
    }
    .Toastr__transition-leave-to {
        margin-bottom: -3.5rem;
        opacity: 0;
    }
</style>
